import { useCallback, useEffect, useState } from "react";
import smsService from "../sms.service";
import { ResponseGetGroupsPhone } from "../groupPhone.interface";

const useGetGroupPhones = (query: string, enabled = true) => {
  const [data, setData] = useState<ResponseGetGroupsPhone>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return smsService.getGroupPhones(query);
  }, [query]);

  const transformResponse = useCallback((response: ResponseGetGroupsPhone) => {
    if (response) {
      setData(response);
    }
  }, []);
  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [query]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabled]);

  return { data, error, isLoading, refetch };
};

export default useGetGroupPhones;
